import { Stack, Typography } from '@mui/joy';
import { memo } from 'react';
import { FcExpired } from 'react-icons/fc';

const InvalidAccess = memo(() => {
  return (
    <Stack justifyContent="center" alignItems="center" flexGrow={1} rowGap={5}>
      <FcExpired size={140} />
      <Typography level="body-md" fontWeight={600}>
        유효하지 않은 접근입니다.
      </Typography>
    </Stack>
  );
});

InvalidAccess.displayName = 'InvalidAccess';

export { InvalidAccess };

